<template>
  <div class="report-section mt-7">
    <div class="flex flex-row items-center mb-3 header">
      <div
        class="self-stretch w-1 mr-2 rounded"
        :class="[!isLoading && color, {'bg-secondary-40': isLoading} ]"
      >
      </div>
      <p
        class="mr-1 text-base font-bold"
        :class="{ 'text-secondary-40': isLoading, 'text-secondary-100': !isLoading }"
      >
        {{ title }}
      </p>
      <i
        v-if="tooltip"
        v-show="!isLoading"
        class="fas fa-question-circle text-secondary-40 cursor-pointer"
        v-tooltip="tooltip"
      />
    </div>
    <div class="body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'bg-primary-90',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
}
</script>
